export default class RandomColor {
  static getRandomColorBasedOnNumber(number: number): string {
    const hue = number * 137.508; // use golden angle approximation
    return `hsl(${hue},50%,50%)`;
  }
}
